import { render } from "./MisPedidos.vue?vue&type=template&id=13f8fe24"
import script from "./MisPedidos.vue?vue&type=script&lang=js"
export * from "./MisPedidos.vue?vue&type=script&lang=js"

import "./MisPedidos.vue?vue&type=style&index=0&id=13f8fe24&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__